import {createContext, useContext} from 'react';
import {GameStore} from '@/entities/game/model/GameStore';
import {ErrorStore} from '@/entities/error/model/ErrorStore';
import {UserStore} from '@/entities/user/model/UserStore';
import {LuckyStore} from '@/entities/lucky/model/LuckyStore';
import {TeamStore} from '@/entities/team/model/TeamStore';
import {SoundStore} from '@/entities/sound/model/SoundStore';
import {ForecastStore} from '@/entities/forecast/model/ForecastStore';
import {InventoryStore} from "@/entities/inventory/model/InventoryStore";
import {EffectsStore} from "@/entities/effects/model/EffectsStore";
import {ModalStore} from "@/entities/modals/model/ModalStore";
import {QuestStore} from "@/entities/quest/model/QuestStore";
import {RatingStore} from "@/entities/rating/model/RatingStore";

export class RootStore {
    userStore = new UserStore(this);
    gameStore = new GameStore(this);
    teamStore = new TeamStore(this);
    ratingStore = new RatingStore(this);
    inventoryStore = new InventoryStore(this);
    luckyStore = new LuckyStore(this);
    forecastStore = new ForecastStore(this);
    effectsStore = new EffectsStore(this);
    questsStore = new QuestStore(this);
    modalStore = new ModalStore(this);
    errorStore = new ErrorStore();
    soundStore = new SoundStore();
}

const Ctx = createContext<RootStore | null>(null);
export const StoreProvider = Ctx.Provider;

export const useStore = () => {
    const store = useContext(Ctx);
    if (!store) {
        console.error('StoreProvider is missing! Stack:', new Error().stack);
        throw new Error('StoreProvider is missing');
    }
    return store;
};

// export const useLucky   = () => useStore().luckyStore;
// export const useGame   = () => useStore().gameStore;
// export const useUser   = () => useStore().userStore;
// export const useTeam   = () => useStore().teamStore;
// export const useSound   = () => useStore().soundStore;
// export const useForecast   = () => useStore().forecastStore;
// export const useInventory   = () => useStore().inventoryStore;
// export const useEffects   = () => useStore().effectsStore;
// export const useModal   = () => useStore().modalStore;
// export const useError   = () => useStore().errorStore;
